import { Toolbar } from "@material-ui/core"
import React, { Fragment, useEffect, useState } from "react"
import { Route, Switch, useHistory } from "react-router"
import Header from "../../components/Header"
import Home from "./Home"

const Main = () => {
    const history = useHistory()
    const [userType] = useState(() => localStorage.getItem('user'))
    useEffect(() => {
        if (userType !== 'sales_channel') {
            history.replace(`/${userType}/home`)
        }
    }, [userType])

    return <Fragment>
        <Header title="爱到底渠道" />
        <Toolbar />
        <Switch>
            <Route path="/channel/home">
                <Home />
            </Route>
        </Switch>
    </Fragment>
}

export default Main